import { BASE_CAMPAIGN_NAME } from './utm-campaign-name';

export const HWS_MEDIA_KMP_SESSION_KEY = 'hws-media-kmp';

export type MediaKmpSessionData = {
    utmTerm: string;
    campaignName: string;
};

export function isPersistedMediaCampaignName(campaignName: string | undefined): boolean {
    return Boolean(campaignName?.trim()) && campaignName !== BASE_CAMPAIGN_NAME;
}

export function readMediaKmpSession(storage: Storage): MediaKmpSessionData | undefined {
    try {
        const raw = storage.getItem(HWS_MEDIA_KMP_SESSION_KEY);
        if (!raw) {
            return undefined;
        }

        const parsed: unknown = JSON.parse(raw);
        if (!isMediaKmpSessionData(parsed)) {
            return undefined;
        }
        if (!isPersistedMediaCampaignName(parsed.campaignName)) {
            return undefined;
        }
        return parsed;
    } catch {
        return undefined;
    }
}

export function writeMediaKmpSession(storage: Storage, data: MediaKmpSessionData): void {
    if (!data.utmTerm.trim() || !isPersistedMediaCampaignName(data.campaignName)) {
        return;
    }

    try {
        storage.setItem(
            HWS_MEDIA_KMP_SESSION_KEY,
            JSON.stringify({
                utmTerm: data.utmTerm.trim(),
                campaignName: data.campaignName.trim(),
            } satisfies MediaKmpSessionData),
        );
    } catch {
        return;
    }
}

function isMediaKmpSessionData(value: unknown): value is MediaKmpSessionData {
    if (!value || typeof value !== 'object') {
        return false;
    }
    const record = value as Record<string, unknown>;
    return typeof record['utmTerm'] === 'string' && typeof record['campaignName'] === 'string';
}
